module.exports = __webpack_public_path__ + "static/media/GT-Standard-L-Extended-Medium.c2d239df.otf";